/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDeviceTypes } from 'app/entities/device-type/device-type.reducer';
import { getEntities as getDeviceManufacurers } from 'app/entities/device-manufacurer/device-manufacurer.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './device.reducer';

export const DeviceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const deviceTypes = useAppSelector(state => state.deviceType.entities);
  const deviceManufacurers = useAppSelector(state => state.deviceManufacurer.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const deviceEntity = useAppSelector(state => state.device.entity);
  const loading = useAppSelector(state => state.device.loading);
  const updating = useAppSelector(state => state.device.updating);
  const updateSuccess = useAppSelector(state => state.device.updateSuccess);

  const handleClose = () => {
    navigate(`/device${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDeviceTypes({}));
    dispatch(getDeviceManufacurers({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.releaseDate !== undefined && typeof values.releaseDate !== 'number') {
      values.releaseDate = Number(values.releaseDate);
    }
    if (values.updatedDate !== undefined && typeof values.updatedDate !== 'number') {
      values.updatedDate = Number(values.updatedDate);
    }
    if (values.discontinuedDate !== undefined && typeof values.discontinuedDate !== 'number') {
      values.discontinuedDate = Number(values.discontinuedDate);
    }
    if (values.mrp !== undefined && typeof values.mrp !== 'number') {
      values.mrp = Number(values.mrp);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...deviceEntity,
      ...values,
      classification: deviceTypes.find(it => it.id.toString() === values.classification?.toString()),
      manufacturer: deviceManufacurers.find(it => it.id.toString() === values.manufacturer?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...deviceEntity,
          classification: deviceEntity?.classification?.id,
          manufacturer: deviceEntity?.manufacturer?.id,
          hospital: deviceEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.device.home.createOrEditLabel" data-cy="DeviceCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.device.home.createOrEditLabel">Create or edit a Device</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="device-id"
                  label={translate('tinyMedicRestApp.device.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tinyMedicRestApp.device.code')} id="device-code" name="code" data-cy="code" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.description')}
                id="device-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.implant')}
                id="device-implant"
                name="implant"
                data-cy="implant"
                check
                type="checkbox"
              />
              <ValidatedField label={translate('tinyMedicRestApp.device.name')} id="device-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.mfgCode')}
                id="device-mfgCode"
                name="mfgCode"
                data-cy="mfgCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.riskClass')}
                id="device-riskClass"
                name="riskClass"
                data-cy="riskClass"
                type="text"
              />
              <ValidatedField label={translate('tinyMedicRestApp.device.slug')} id="device-slug" name="slug" data-cy="slug" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.country')}
                id="device-country"
                name="country"
                data-cy="country"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.releaseDate')}
                id="device-releaseDate"
                name="releaseDate"
                data-cy="releaseDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.updatedDate')}
                id="device-updatedDate"
                name="updatedDate"
                data-cy="updatedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.discontinued')}
                id="device-discontinued"
                name="discontinued"
                data-cy="discontinued"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.discontinuedDate')}
                id="device-discontinuedDate"
                name="discontinuedDate"
                data-cy="discontinuedDate"
                type="text"
              />
              <ValidatedField label={translate('tinyMedicRestApp.device.mrp')} id="device-mrp" name="mrp" data-cy="mrp" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.microSec')}
                id="device-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.timestampentry')}
                id="device-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.lastupdated')}
                id="device-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.cursor')}
                id="device-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.device.active')}
                id="device-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                id="device-classification"
                name="classification"
                data-cy="classification"
                label={translate('tinyMedicRestApp.device.classification')}
                type="select"
              >
                <option value="" key="0" />
                {deviceTypes
                  ? deviceTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="device-manufacturer"
                name="manufacturer"
                data-cy="manufacturer"
                label={translate('tinyMedicRestApp.device.manufacturer')}
                type="select"
              >
                <option value="" key="0" />
                {deviceManufacurers
                  ? deviceManufacurers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="device-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.device.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/device" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeviceUpdate;
